import { render } from "./forgot_email.vue?vue&type=template&id=0c14fafd"
import script from "./forgot_email.vue?vue&type=script&lang=js"
export * from "./forgot_email.vue?vue&type=script&lang=js"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__